<template>
  <div :class="iszzc ? 'noscroll' : 'shop'">
    <div class="swiper">
      <img :src="shopData.goods_image" class="swiper_img" alt="" />
    </div>
    <div v-if="isNewMode">
      <div class="new_mode_content">
        <div class="top_orange flex_b">
          <div class="left_max_jifen flex">
            <strong>{{ shopData.price }}</strong>
            <span>积分</span>
          </div>
        </div>
        <div class="goods_desx_box_x">
          <p class="goods_name">{{ shopData.goods_name }}</p>
        </div>
      </div>
      <div
        class="check_spc flex_b"
        v-if="shopData.spec_name && shopData.spec_name != ''"
      >
        <span style="color: #999999">已选</span>
        <b>{{ shopData.spec_name }}</b>
      </div>
    </div>
    <!--  内容-->
    <div class="shop_main" v-else>
      <div class="title">
        <span>{{ shopData.goods_name }}</span>
      </div>

      <div class="integral_price flex_b">
        <div class="price">
          <span>
            {{ shopData.price }}
            <b>积分</b>
          </span>
        </div>
        <b style="padding-top: 0.52rem">已选:{{ shopData.spec_name }}</b>
      </div>
    </div>
    <!--商品详情-->
    <div class="shop_det">
      <div class="shop_title">{{ isNewMode ? "商品详情" : "产品详情" }}</div>
      <!--           <img :src="ossImgPath+'fx.png'" alt="" />-->
      <div
        class="shop_del"
        :class="isNewMode ? 'new_img_Box' : ''"
        v-html="shopData.description"
      ></div>
    </div>
  </div>
</template>
<script>
import icon from "@/components/iconfont.vue";
import { sendRequest, getOpenid } from "@/assets/public";
import mloading from "@/components/loading.vue";
import { Dialog, Toast } from "vant";
import share from "../../share.js";
import urlconfig from "@/config.js";

export default {
  components: {
    // 'qdd-icon': icon,
  },
  data() {
    return {
      colorList: ["#00B97C", "#FF5736", "#FFBE00", "#F40923"],
      showLoading: false,
      oderId: "",
      order_parent_sn: "",
      shopData: {},
      isNewMode: localStorage.getItem("isNewMode"), //20240312改版
    };
  },
  created() {
    this.oderId = this.$route.query.oderId || this.$route.params.oderId;
    this.order_parent_sn =
      this.$route.query.order_parent_sn || this.$route.params.order_parent_sn;
    this.goodDetails();
  },

  mounted() {},

  methods: {
    // 商品详情
    async goodDetails(isload) {
      let params = {
        oderId: this.oderId,
        order_parent_sn: this.order_parent_sn,
      };
      this.showLoading = true;
      let { content, status } = await sendRequest(
        "order/orderSnapshot",
        params
      );
      this.shopData = content.goods || {};
    },
  },
};
</script>
<style>
.my-swipe_vertical.van-swipe {
  top: inherit !important;
  position: absolute !important;
  /* width: auto; */
}
.my-swipe_vertical .van-swipe-item {
  width: 100% !important;
}
</style>
<style scoped>
.tankuang_zhezhaoceng {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  z-index: 500;
}

.tank_zzc {
  width: 85%;
  height: 200px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.tank_title {
  text-align: center;
  line-height: 40px;
  color: #333;
  font-weight: 600;
  font-size: 16px;
  margin-top: 18px;
}

.tkzzc {
  box-sizing: border-box;
  margin: 0 40px 10px;
  font-size: 16px;
  color: #919191;
}

.tkzzc span {
  color: #fb0202;
}

.Determinetocancel {
  display: flex;
  width: 100%;
  height: 50px;
  border-top: 1px solid #eaeaea;
  line-height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
}

.Determinetocancel p {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  color: #333333;
  font-weight: 600;
}

.Determinetocancel p:nth-child(2) a {
  width: 100%;
  height: 100%;
  display: block;
  color: #6b80a5;
}

.Determinetocancel p + p {
  border-left: 1px solid #eaeaea;
}

/*选择规格*/
.mendian {
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.6rem;
  color: #fff;
  background: #ff6d20;
  width: 15rem !important;
}

.mendian_btn {
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.6rem;
  color: #fff;
  background: #ff6d20;
}
.new_footer.bot .operation.mendian_btn {
  width: 4.8rem;
  margin-right: 0.4rem;
  height: 1.44rem;
  line-height: 1.44rem;
  border-radius: 0.72rem;
  margin-top: 0.22rem;
  background: #ff463a;
}

.cart_footer {
  display: flex;
}

.cart_footer button {
  width: 7.5rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.6rem;
  color: #fff;
  background: #ff6d20;
}

.cart_footer button.redbg {
  background: #fd3e3e;
}
.hot_img_t {
  width: 0.44rem;
  height: 0.56rem;
  margin-top: -0.1rem;
  vertical-align: middle;
}

.cart_contant {
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  /* height: 100%; */
  z-index: 105;
  overflow: hidden;
}

.cart_contant_warp {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  /*padding: 0 0.8rem 0.4rem;*/
  z-index: 105;
}

.cart_good {
  position: relative;
  font-size: 0.48rem;
  color: #999999;
  height: 3.2rem;
  margin: 0 0.8rem 0.4rem;
}

.cart_good img {
  width: 4rem;
  height: 4rem;
  border-radius: 10px;
  position: absolute;
  top: -0.8rem;
  left: 0;
}

.cart_good span {
  font-size: 0.72rem;
  color: #fd3e3e;
  padding-left: 4.6rem;
  padding-top: 0.6rem;
  display: block;
  overflow: hidden;
  line-height: 0.72rem;
  display: flex;
  align-items: center;
}

.cart_good p {
  padding-left: 4.6rem;
  color: #999999;
  font-size: 0.48rem;
  padding-top: 0.4rem;
}

.cart_good span b {
  width: 1.4rem;
  height: 0.56rem;
  line-height: 0.66rem;
  border: 1px solid rgba(253, 62, 62, 1);
  font-size: 0.4rem;
  color: #fd3e3e;
  border-radius: 14px;
  text-align: center;
  margin-top: 0.05rem;
  margin-left: 0.2rem;
}

.cart_good_size {
  padding-top: 0.8rem;
  overflow: hidden;
  margin: 0 0.8rem 0.4rem;
}

.cart_good_size .active {
  color: #fff !important;
  background: #fd3e3e !important;
  border: 1px solid #fd3e3e !important;
}

.cart_good_size .no_active {
  color: #fff !important;
  background: #dddddd !important;
  border: 1px solid #dddddd !important;
}

.cart_good_size p {
  color: #333333;
  font-size: 0.6rem;
}

.cart_good_size ul {
  display: flex;
  flex-flow: wrap;
}

.cart_good_size ul li:nth-child(3n) {
  margin-right: 0;
}

.cart_good_size ul li {
  float: left;
  min-width: 3.1rem;
  height: 0.96rem;
  line-height: 0.96rem;
  text-align: center;
  background: #fff;
  border: 1px solid #dddddd;
  border-radius: 0.2rem;
  color: #999;
  margin-right: 0.4rem;
  margin-top: 0.4rem;
}

.kuaidi {
  width: 100%;
}

.cart_good_size .kuaidi li:nth-child(4n) {
  margin-right: 0;
}

.cart_good_size .kuaidi li:nth-child(3n) {
  margin-right: 0.4rem;
}

.cart_good_size .kuaidi li {
  padding: 0 0.4rem;
}

.share_pop {
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  width: 100%;
  z-index: 102;
}

.share_pop p {
  text-align: center;
  font-size: 0.6rem;
  color: #8b8b8b;
  border-top: 1px solid #eee;
  line-height: 1.96rem;
}

.share_pop div {
  padding: 0.6rem 0;
  color: #999999;
  font-size: 0.56rem;
}

.share_pop span {
  width: 7.5rem;
  display: block;
  text-align: center;
}

.share_pop span b {
  display: block;
  width: 7.5rem;
  padding-top: 0.4rem;
}

.cor {
  color: #fd3e3e;
}

.add_car_img {
  width: 1.4rem;
  height: 1.4rem;
  position: fixed;
  right: 0.4rem;
  top: 0.4rem;
  padding: 0.2rem;
  z-index: 99;
}

.goPre {
  width: 1.4rem;
  height: 1.4rem;
  position: fixed;
  left: 0.4rem;
  top: 0.2rem;
  padding: 0.2rem;
  z-index: 9999;
}

.swiper {
  width: 100%;
  height: 15.08rem;
  position: relative;
}

.swiper_img {
  width: 100%;
  height: 100%;
  display: block;
  border: none;
}

.my-swipe {
  height: 100%;
}

.custom-indicator {
  position: absolute;
  width: 1.6rem;
  height: 0.96rem;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  left: 50%;
  bottom: 0.4rem;
  transform: translate(-50%, 0);
  border-radius: 0.48rem;
  font-size: 0.48rem;
  line-height: 0.96rem;
  text-align: center;
}

/* 商品内容 */
.shop_main {
  padding: 0.6rem 0.8rem;
  background: #ffffff;
}

.title {
  font-size: 0.6rem;
  color: #171717;
  line-height: 0.8rem;
  /* max-height: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
  text-align: left;
}

.integral_price .price {
  color: #fd3e3e;
  font-size: 0.72rem;
  line-height: 0.72rem;
  padding-top: 0.52rem;
  display: flex;
  justify-content: space-between;
}
.integral_price .price span {
  display: flex;
  align-items: center;
}

.integral_price .price b {
  width: 1.4rem;
  height: 0.56rem;
  text-align: center;
  display: inline-block;
  line-height: 0.64rem;
  color: #fd3e3e;
  font-size: 0.4rem;
  border: 1px solid rgba(253, 62, 62, 1);
  border-radius: 14px;
}

.integral_price .price img {
  float: right;
  width: 0.8rem;
  height: 0.8rem;
}

.integral_price .cs_price {
  font-size: 0.48rem;
  color: #999999;
  padding: 0.4rem 0;
}

/* 地址 */
.city {
  padding: 0.6rem 0.8rem;
  background: #ffffff;
  margin-top: 0.4rem;
}

.send {
  font-size: 0.56rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.6rem;
}

.city_title {
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.6rem;
  width: 9rem;
  text-align: right;
}

/* 商品详情 */

.shop_title {
  padding: 0.8rem 0;
  text-align: center;
  font-size: 0.64rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

/*    footer*/
.opera {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #f4f6f8;
  z-index: 100;
}

.bot {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 2rem;
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #f4f6f8;
  z-index: 100;
}

.collection {
  width: 2rem;
  padding-top: 0.4rem;
  text-align: center;
}

.collection img {
  width: 0.6rem;
  height: 0.54rem;
}

.collection div {
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.6rem;
}

.operation {
  flex: 1;
}

.operation div {
  width: 50%;
  background: #fd3e3e;
  color: #ffffff;
  font-size: 0.6rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: center;
  line-height: 2rem;
}

.operation .add_car {
  background: #ff6d20;
}

/* 规格 */
.specific {
  margin-top: 0.8rem;
}

.opera_title {
  font-size: 0.6rem;
  color: rgba(51, 51, 51, 1);
  line-height: 1.04rem;
}

.speci_list {
  flex-wrap: wrap;
}

.speci_list .key {
  background: #fd3e3e;
  color: #ffffff;
  border-color: #fd3e3e;
}

.speci_list div {
  min-width: 2.4rem;
  padding: 0 0.5rem;
  height: 0.96rem;
  font-size: 0.48rem;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  line-height: 0.96rem;
  text-shadow: 0px 0.06rem 0.48rem rgba(159, 159, 159, 0.42);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 0.2rem;
  text-align: center;
  margin-right: 0.4rem;
  margin-bottom: 0.4rem;
}

.sort {
  float: right;
}

.sort input {
  text-align: center;
  width: 2rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.56rem;
  color: #333;
  padding: 0 0.2rem;
  border: none;
}

.sort img {
  width: 1.04rem;
  height: 1.04rem;
}

.sf_exchangetip {
  font-size: 0.4rem;
  line-height: 0.6rem;
  color: #999;
  width: 100%;
  margin: 0.14rem 0.8rem 0.4rem;
}

.close {
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
  width: 1rem;
  height: 1rem;
}
.custom-indicator.NewMode {
  right: 0rem;
  left: inherit;
  height: 1rem;
  line-height: 1rem;
  bottom: 0.7rem;
}
.swiper_text_x {
  width: 6.78rem;
  text-align: center;
}

/*---------------------- 分享模块 ---------------------*/

.share_image {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10580;
}

.share_image .shareImg {
  width: 12rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -60%);
}

.share_image .shareImg img {
  width: 100%;
  display: block;
}

.save_code,
.over_code {
  position: absolute;
  width: 100%;
  bottom: -1.8rem;
  left: 50%;
  transform: translate(-50%, 0);
  height: 1.5rem;
  background: rgba(253, 62, 62, 1);
  border-radius: 0.1rem;
  text-align: center;
  line-height: 1.7rem;
  font-size: 0.6rem;
  color: rgba(255, 255, 255, 1);
}

.over_code {
  bottom: -3.6rem;
  background: #fff;
  color: #333333;
}

.reminder {
  width: 100%;
  height: 100%;
  background-color: rgba(170, 46, 46, 0.2);
  position: absolute;
  z-index: 100;
  top: 0;
}

.reminder_main {
  width: 93%;
  height: 30%;
  background-color: rgba(253, 62, 62, 1);
  margin: auto;
  margin-top: 45%;
}

/*---------------------- 分享模块 end ----------------------*/
</style>
<style>
.check_spc {
  height: 2rem;
  line-height: 2rem;
  background: #fff;
  width: 13.16rem;
  margin: 0 auto;
  padding: 0 0.4rem 0 0.64rem;
  border-radius: 0.4rem;
}
.shop {
  background: #f4f6f8;
  padding-bottom: 2rem;
}

.noscroll {
  background: #f4f6f8;
  overflow: hidden;
  height: 100vh;
}

.shop_del {
  width: 100%;
}

.shop_del img {
  vertical-align: top;
  width: 100% !important;
  display: block;
}

.shop_del image {
  vertical-align: top;
  width: 100% !important;
}

.new_mode_content {
  width: 14.2rem;
  border: 0.4rem;
  background: #ffffff;
  margin: 0.4rem auto;
  border-radius: 0.4rem;
}

.new_mode_content .top_orange {
  background: linear-gradient(90deg, #ff463a 0%, #ff6528 100%);
  border-radius: 0.4rem 0.4rem 0px 0px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.48rem;
  padding: 0 0.4rem 0 0.64rem;
  height: 2.2rem;
  line-height: 2.2rem;
}

.new_mode_content .left_max_jifen strong {
  font-size: 0.96rem;
  color: #ffffff;
  font-weight: bold;
  margin-right: 0.12rem;
}

.new_mode_content .left_max_jifen span {
  font-size: 0.48rem;
  color: #ffffff;
  margin-right: 0.28rem;
}

/* .new_mode_content .left_max_jifen b {
		text-decoration: line-through;
	} */

.hot_targ {
  height: 0.8rem;
  line-height: 0.8rem;
  padding: 0 0.22rem 0 0.28rem;
  border: 1px solid rgba(255, 255, 255, 0.33);
  display: block;
  border-radius: 0.2rem;
  margin-top: 0.56rem;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 0.44rem;
}

.goods_desx_box_x {
  width: 13.16rem;
  margin: -0.4rem auto 0;
  padding: 0.64rem 0.4rem 0.4rem 0.64rem;
  border-radius: 0.4rem;
  background: linear-gradient(180deg, #fff1f1 0%, #ffffff 100%);
}

.goods_desx_box_x .goods_name {
  font-weight: 500;
  font-size: 0.6rem;
  color: #333;
  line-height: 0.8rem;
  /* height: 1.2rem; */
  /* margin-bottom: 0.2rem; */
}

.targ_max_box {
  background: linear-gradient(
    90deg,
    rgba(255, 245, 236, 0.36) 0%,
    #feefea 100%
  );
  border-radius: 0.16rem;
  border: 1px solid #f4d7d7;
  color: #ff463a;
  font-size: 0.48rem;
  /* height: 1rem; */
  /* line-height: 1rem; */
  padding: 0.18rem 0.4rem 0.18rem 0.2rem;
  margin: 0 0 0.4rem;
}

.targ_max_box span {
  /* height: 0.64rem;
		line-height: 0.66rem; */
  border-radius: 0.12rem;
  color: #ffffff;
  padding: 0 0.2rem;
  margin-right: 0.2rem;
  /* vertical-align: middle; */
  border: 1px solid transparent;
  /* display: inline-block; */
}
.targ_max_box .targ_store {
  background: #ffebe6;
  border-color: #ff5736;
  color: #ff5736;
  /* height: 0.64rem;
			    line-height: 0.66rem; */
  padding: 0 0.2rem;
}

.orange_bg {
  background: #ff8904;
}

.targ_max_box .black {
  background: #332a1f;
  color: #ffdcb1;
}

.characteristic {
  padding: 0.56rem 0 0.48rem;
  color: #333333;
  font-size: 0.48rem;
  border-top: 1px solid #f6f6f6;
}

.characteristic div {
  height: 0.56rem;
  /* line-height: 0.56rem; */
  display: flex;
  align-items: center;
}

.characteristic img {
  width: 0.56rem;
  height: 0.56rem;
  margin-top: -0.1rem;
  margin-right: 0.12rem;
  display: inline-block;
  border: 0 none;
}

.city.new_city_s {
  width: 14.2rem;
  margin: 0 auto;
  height: 1.76rem;
  line-height: 1.76rem;
  background: #ffffff;
  border-radius: 0.4rem;
  padding: 0;
}

.city.new_city_s .send {
  margin-left: 0.6rem;
  line-height: 1.76rem;
  color: #333333;
  font-size: 0.56rem;
  font-weight: 400;
}

.city.new_city_s .iconright {
  margin-right: 0.64rem;
}

.city.new_city_s .city_title {
  line-height: 1.76rem;
}

.shop_del.new_img_Box {
  width: 14.2rem;
  margin: 0 auto;
}
.more_suggest {
  width: 14.2rem;
  margin: 0.4rem auto 0;
  background: #ffffff;
  border-radius: 0.4rem;
}
.more_suggest .text_h1 {
  color: #333333;
  font-size: 0.56rem;
  padding: 0.6rem 0 0.6rem 0.6rem;
  font-weight: 500;
}
.more_suggest ul {
  padding: 0 0.6rem;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.more_suggest li {
  width: 4.12rem;
  margin-bottom: 0.4rem;
  margin-right: 0.32rem;
}
.more_suggest li:nth-child(3n) {
  margin-right: 0;
}
.more_suggest li p {
  height: 1.24rem;
  line-height: 0.64rem;
  font-size: 0.48rem;
  margin: 0.16rem 0 0.12rem;
}
.more_suggest li img {
  width: 4.12rem;
  height: 4.12rem;
  border-radius: 0.4rem;
  display: block;
}
.more_suggest .price {
  color: #ff463a;
  font-size: 0.4rem;
  height: 0.56rem;
  line-height: 0.56rem;
}
.more_suggest .price strong {
  color: #ff463a;
  font-size: 0.56rem;
  font-weight: bold;
  margin-right: 0.08rem;
}
.bot.new_footer {
  justify-content: space-between;
}
.bot.new_footer .operation div {
  width: 4.8rem;
  height: 1.44rem;
  line-height: 1.44rem;
  border-radius: 0.72rem;
  color: #ffffff;
}
.bot.new_footer .add_car {
  background: #ffbd02;
  margin-right: 0.4rem;
}
.bot.new_footer .operation {
  flex: inherit;
  margin-right: 0.4rem;
  margin-top: 0.38rem;
}
.bot.new_footer .collection img {
  width: 0.64rem;
  height: 0.64rem;
}
.bot.new_footer .collection.left_home {
  margin-left: 0.4rem;
}
.bot.new_footer .collection div {
  color: #333;
}
.city.new_city_s .city_title {
  margin-right: 0.4rem;
}
.add_car_img.share_newMode {
  right: 2.4rem;
}

.my-swipe_vertical {
  height: 1rem;
  line-height: 1rem;
  width: 6.78rem;
  /* padding:0 0.76rem ; */
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 0.7rem;
  top: inherit;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  font-size: 0.44rem;
  border-radius: 0 0.5rem 0.5rem 0;
  overflow: hidden;
}
</style>